import { styled } from '@vebox/etui-system';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { A } from '@vebox/etui-system-elements';

const _excluded = ["theme", "hoverBg"];
var DropdownListItem = styled(A).attrs(_ref => {
  let {
      theme,
      hoverBg
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    height: '40px',
    px: `${theme.spacing.lg}px`,
    py: `${theme.spacing.md}px`,
    display: 'flex',
    alignItems: 'center',
    color: `${theme.palette.text.primary}`
  }, props);
})`
  text-decoration: none;
  :hover {
    background-color: ${({
  theme,
  hoverBg
}) => hoverBg || theme.palette.grey[10]};
  }
  :active {
    background-color: ${({
  theme
}) => theme.palette.grey[20]};
  }
`;

const _excluded$1 = ["styles", "onClick", "children"];
const Item = _ref => {
  let {
      styles = {},
      onClick,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/createElement(DropdownListItem, _extends({}, styles.root, {
    onClick: onClick
  }, rest), children);
};
var Item$1 = {
  Item
};

export default Item$1;
